import esLa from './es-la';
import enUs from './en-us';

const language = {
  ...esLa,
  ...enUs,
};

export default language;
